<template>
  <div class="journey" id="#journey">
    <div class="journey-background-wrapper">
      <JourneyBackground />
    </div>
    <div class="journey-steps">
      <div class="journey-step" v-for="item in steps" :key="item.id">
        <JourneyStep v-bind:item="item" />
      </div>
    </div>
  </div>
</template>

<script>
import { gsap } from "gsap";
import * as ScrollMagic from "scrollmagic";
import { TweenMax, TimelineMax } from "gsap";
import { ScrollMagicPluginGsap } from "scrollmagic-plugin-gsap";
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";
import JourneyBackground from "../assets/svg/journey-background.svg";
import JourneyStep from "./JourneyStep";

gsap.registerPlugin(DrawSVGPlugin);

ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax);

let controller = new ScrollMagic.Controller();
let timeline = gsap.timeline();

export default {
  name: "Journey",
  components: {
    JourneyBackground: JourneyBackground,
    JourneyStep
  },
  props: {
    steps: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  data() {
    return {
      errors: []
    };
  },
  created() {
    window.addEventListener("resize", this.resize);
  },
  destroyed() {
    window.removeEventListener("resize", this.resize);
  },
  mounted() {
    this.init();
  },
  methods: {
    resize() {},
    init() {
      timeline.to(
        ".journey-line-1",
        6,
        { drawSVG: "100%", ease: "power1.inOut" },
        0
      );
      timeline.from(
        ".journey-line-2",
        5.9,
        { drawSVG: 0, ease: "power1.inOut" },
        0
      );

      var h = document.querySelector(".journey svg").getBoundingClientRect()
        .height;
      let scene = new ScrollMagic.Scene({ // eslint-disable-line no-unused-vars
        triggerElement: ".journey",
        duration: screen.height > 1024 ? h*0.6 : h*0.55,
        triggerHook: screen.height > 768 ? 0.5 : screen.height < 600 ? 0.3 : 0.2,
        tweenChanges: true
      })
        .setTween(timeline)
        .addTo(controller);
      //scene.on("progress", function(event) {
      // console.log("Scene progress: " + event.progress);
      //});
    }
  },
  computed: {
    activeCountryDate() {
      return Object.keys(this.dayData.data)[this.dayNr];
    }
  },
  ready: function() {
    window.addEventListener("resize", this.chartSize);
  },
  beforeDestroy: function() {
    window.removeEventListener("resize", this.chartSize);
  }
};
</script>

<style>
.multiselect__tag {
  background-color: #30b5e4;
  color: #0b1f3e;
}
</style>

<style scoped lang="scss">
.journey {
  position: relative;
  display: flex;
  padding-top: 50px;
  overflow: hidden;
  margin-bottom: 100px;
  &::after {
    content: '';
    display: inline-block;
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 75px;
    background: linear-gradient(rgba(255,255,255,0), rgba(255,255,255));
  }
}

.journey-background-wrapper {
  position: absolute;
  width: 75%;
  left: 12.5%;
  svg {
    width: 100%;
    height: auto;
  }
}

.journey-steps {
  position: relative;
  width: 100%;

  .journey-step {
    display: flex;
    flex-wrap: nowrap;
    width: 100%;
    padding: 0 5%;
    box-sizing: border-box;
    margin: 0 auto;
    max-width: 1600px;
  }
}
</style>